import { AxiosResponse } from 'axios';

import axiosInstance from './axiosInstance';
import { requestErrorHandler, responseErrorHandler } from './interceptorErrorHandler';

// Request interceptor for error handling
axiosInstance.interceptors.request.use((config) => {
  return config;
}, requestErrorHandler);

// Response interceptor for error handling
axiosInstance.interceptors.response.use((response: AxiosResponse) => {
  return response;
}, responseErrorHandler);
